import {Injectable} from '@angular/core';
import {UserSessionDto} from '../../../Models/User/user-session.interface';

@Injectable({
  providedIn: 'root'
})
export class UserSessionModelService {

  tableName: string = 'yu_v3_user_session';
  data: UserSessionDto | null = null;

  /**
   * Obtener la clave del usuario actual
   *
   */
  get currentUserId(): string | null {
    const user: UserSessionDto | null = this.get();
    return user?.id ? String(user.id) : null;
  }


  /**
   * Recuperar la sesión
   *
   */
  get(): UserSessionDto | null {
    const dataAux: string | null = localStorage.getItem(this.tableName);
    this.data = dataAux ? JSON.parse(dataAux) : null;

    return this.data;
  }


  /**
   * Editar sesión
   *
   */
  set(data: UserSessionDto) {
    this.data = data;
    localStorage.setItem(this.tableName, JSON.stringify(data));

    return this.data;
  }


  /**
   * Eliminar sesión
   *
   */
  delete() {
    this.data = null;
    localStorage.clear();

    return this.data;
  }

}
